/**
 * 个人权限
 */
export const CURRENT_PERMISSIONS = 'current_permissions'
/**
 * 所有时区选项
 */
export const ALL_TIME_ZONE = 'all_time_zone'